<script setup lang="ts">
/**
 * UI-kit component
 * Category: 'Menus'
 * Name: 'NavigationLinkTabs'
 * FIGMA: ''
 */
import type { NavigationLinkTabsProps } from '../types/interfaces'

import LinkNavTab from './LinkNavTab.vue'

defineOptions({
  name: 'NavigationLinkTabs',
})

defineProps<NavigationLinkTabsProps>()
</script>

<template>
  <div class="nav-tabs">
    <template
      v-for="(link, index) in config"
      :key="index"
    >
      <LinkNavTab
        v-if="link.visible"
        :text="link.text"
        :to="link.to"
        :selected="link.selected"
        :disabled="link.disabled"
      />
    </template>
  </div>
</template>

<style lang="scss" scoped src="../styles/_navigation-link-tabs.scss" />
